import { Button } from "@mui/material";
import { useState } from "react";
import products from "../../services/data/data";
import ProductCard from "./ProductCard";
import { AnimatePresence, motion } from "framer-motion";
import { DownloadForOffline, Send } from "@mui/icons-material";

const filters = [
  "All",
  "Cap",
  "Container",
  "Lock Jar",
  "Jar Cap",
  "Measuring Cup",
];
const ProductsHome = () => {
  var [filter, setFilter] = useState(filters[0]);
  const [disabled, setDisabled] = useState(false);
  const cooldownTime = 30000; // 30 seconds

  const handleDownload = () => {
    const fileUrl = "https://vpack.vgroupindustries.com/assets/brochure.pdf";

    // ✅ Open in new tab (for viewing)
    window.open(fileUrl, "_blank");

    setDisabled(true);
    setTimeout(() => {
      setDisabled(false);
    }, cooldownTime);
  };

  return (
    <motion.div
      className="md:mx-16 text-center mt-28 font-HNmed"
      initial={{ y: "100vh" }}
      animate={{ y: 0 }}
      transition={{ delay: 0, duration: 1 }}
      exit={{ x: "100vw" }}
    >
      <div className="relative w-full min-h-20">
        <div className="text-white font-HNlight p-4 text-3xl md:text-5xl tracking-wide text-center">
          Product <strong>Catalogue</strong>
        </div>
        <div className="absolute top-[3.25rem] md:top-3 right-0">
          <Button
            variant="contained"
            onClick={() => {
              const fileUrl =
                "https://vpack.vgroupindustries.com/assets/brochure.pdf"; // Replace with the actual file URL
              const whatsappUrl = `https://wa.me/?text=Check out this Product Brochure: ${encodeURIComponent(
                fileUrl
              )}`;

              window.open(whatsappUrl, "_blank");
            }}
            sx={{
              fontSize: { sm: 1, md: 18 },
              borderRadius: 1,
              paddingY: { sm: 0.8, md: 1.2 },
              fontFamily: "Jost-Reg",

              backgroundColor: "#00E0DA",
              color: "#005B58",
              minWidth: { sm: "10px", md: "60px" },
              textTransform: "none",
            }}
          >
            <span className="hidden md:block pr-2">Product Brochure </span>
            <Send />
          </Button>
          <Button
            variant="contained"
            sx={{
              fontSize: { sm: 6, md: 20 },
              borderRadius: 1,
              paddingY: { sm: 0.8, md: 1.7 },
              fontFamily: "Jost-Reg",

              backgroundColor: "#00E0DA",
              color: "#005B58",
              minWidth: { sm: "20px", md: "60px" },
              textTransform: "none",
            }}
            onClick={handleDownload}
            disabled={disabled}
          >
            <DownloadForOffline />
          </Button>
        </div>
      </div>

      <Filters filter={filter} setFilter={setFilter} />
      <ProductsGallery filter={filter} />
    </motion.div>
  );
};

const Filters = ({ filter, setFilter }) => {
  return (
    <div className="w-full flex-wrap flex md:flex-row justify-center my-1 md:my-5">
      {filters.map((f) => (
        <Button
          variant="contained"
          key={f}
          onClick={() => {
            setFilter(f);
          }}
          sx={{
            fontSize: { sm: 10, md: 22 },
            borderRadius: 10,
            marginY: 1,
            marginX: 2,
            fontFamily: "Jost-Reg",
            paddingX: 4,
            backgroundColor: filter === f ? "#00E0DA" : "#005B58",
            color: filter === f ? "#005B58" : "#00E0DA",
            minWidth: { sm: "20px", md: "80px" },
            textTransform: "none",
          }}
        >
          {f}
        </Button>
      ))}
    </div>
  );
};

const ProductsGallery = ({ filter }) => {
  return (
    <AnimatePresence>
      <div className="flex flex-wrap items-center justify-evenly mx-4">
        {products
          .filter((prod) => {
            return (
              prod.category.toLowerCase() === filter.toLowerCase() ||
              filter.toLowerCase() === "all"
            );
          })
          .map((product) => {
            const key = product.Name;
            return <ProductCard product={product} key={key} />;
          })}
      </div>
    </AnimatePresence>
  );
};

export default ProductsHome;
